import { render, staticRenderFns } from "./activity-collectCards-ranking.vue?vue&type=template&id=f1b2d27a&scoped=true&"
import script from "./activity-collectCards-ranking.vue?vue&type=script&lang=js&"
export * from "./activity-collectCards-ranking.vue?vue&type=script&lang=js&"
import style0 from "./activity-collectCards-ranking.vue?vue&type=style&index=0&id=f1b2d27a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b2d27a",
  null
  
)

export default component.exports